module.exports = __webpack_public_path__ + "images/landing-page-stock-image.png";